// The words of the Workbench polish and the acknowledgment widget (B10 slice S21) that the design system does not
// already define. Everything else these screens draw is D0's: *Panel acknowledgment summary*, *Panel change*, the
// response words and the ring's sentence (ACKSUM_LABELS, RESPONSE_PILL, G8_TEMPLATES), *Coordinator Workbench*
// (NAV_ITEM_LABELS), *Saved views* and *Save view* (FILTERBAR_LABELS, ACTION_LABELS, through S19's select). Each entry
// quotes his glossary verbatim; the D0 word suites discover this module (a lane folder of src/views).

import { defineLabels } from "@/mc/labels";

const KICKOFF =
  "HTML Step 13 card, Kickoff & Packets screen, HM/Recruiter/Interviewer lanes, packet builder, email service, acknowledgment control…";

/** The widget's per-requisition link to the screen the acknowledgments are kept on (G §2, BRD §3.13). */
export const WORKBENCH_LABELS = /* @__PURE__ */ defineLabels({
  kickoffPackets: { text: "Kickoff & Packets" },
});
